module.exports = __webpack_public_path__ + "static/media/create-post-disabled.ee4d10a0.svg";